/* ══════════════════════════════════════════════════════════════════════
   ANTHOLOGY SUBMISSION — vanilla port of the handoff's DCLogic class.
   Same behaviour, no framework. Everything is scoped to .tws-asub so the
   locked chrome and footer are never touched.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  /* Each Shopify section emits its own <script src="tws-asub.js">, so this file
     runs once per section on the theme and once on the local page. Everything
     below must happen exactly once. */
  if (window.__twsAsubInit) return;
  window.__twsAsubInit = true;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- headline type: every word rises out of its own mask ---- */
  function splitWords() {
    var heads = $$('.tws-asub h1, .tws-asub h2, .tws-asub h3');
    var wrap = function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'sw';
            var i = document.createElement('i'); i.textContent = p;
            s.appendChild(i); frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' &&
                   n.tagName !== 'BUTTON' && n.tagName !== 'A') { wrap(n); }
      });
    };
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 52) + 'ms'; });
      };
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ---- reveals: only what starts below the fold is hidden ---- */
  function initReveal() {
    if (REDUCE) return;                       // never leave content hidden
    var els = $$('.tws-asub [data-rv]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var kind = el.getAttribute('data-rv') || 'rise';
        var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
        el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    var pending = [];
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight * 0.88) {
        el.style.opacity = '0'; io.observe(el); pending.push(el);
      }
    });

    /* ── the backstop ──
       Everything above is hidden by JS, and an IntersectionObserver alone must
       never be the only route back: anything that stops those callbacks — a
       throttled tab, an editor iframe, a stale script — would leave the page
       showing the hero and nothing else. This sweep reveals whatever is
       already on screen and can never leave content stranded. */
    var show = function (el) {
      var kind = el.getAttribute('data-rv') || 'rise';
      var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
      el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
      el.style.opacity = '';
    };
    var sweep = function () {
      for (var i = pending.length - 1; i >= 0; i--) {
        var el = pending[i];
        if (el.style.opacity !== '0') { pending.splice(i, 1); continue; }
        if (el.getBoundingClientRect().top < innerHeight * 0.94) { show(el); pending.splice(i, 1); }
      }
      if (!pending.length && timer) { clearInterval(timer); timer = null; }
    };
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    var timer = setInterval(sweep, 300);
    sweep();
  }

  /* ---- the hero object's parallax ---- */
  function initScrollFX() {
    var pars = $$('.tws-asub [data-par]');
    if (!pars.length) return;
    var apply = function () {
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > innerHeight + 240) return;
        var c = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        var amt = parseFloat(el.getAttribute('data-par')) || 0;
        el.style.setProperty('--py', (-c * amt * 100).toFixed(1) + 'px');
      });
    };
    var queued = false;
    var run = function () { queued = false; try { apply(); } catch (e) {} };
    var onScroll = function () { if (queued) return; queued = true; requestAnimationFrame(run); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(run, 260);
    run();
  }

  /* ---- FAQ: one open at a time ---- */
  function initFaq() {
    var faqs = $$('#questions details.faq');
    faqs.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        faqs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---- the project themes ----
     Two mechanisms in one column. The inner .tm rows are an accordion (one
     theme open at a time). The outer .tmbox is a wrapper that only exists as
     a control below 1080: on a phone the seven themes sit behind one
     "See the project themes" button so they never push the form off screen,
     and above 1080 it is forced open because its summary is display:none —
     leaving it closed there would hide the whole column. */
  function initThemes() {
    var box = $('.tws-asub details.tmbox');
    if (box) {
      var wide = innerWidth > 1080;
      box.open = wide;
      addEventListener('resize', function () {
        var now = innerWidth > 1080;
        if (now === wide) return;
        wide = now;
        box.open = now;
      }, { passive: true });
    }
    var themes = $$('.tws-asub details.tm');
    themes.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        themes.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---- the submission form ----
     The handoff bound this to the DC component's onSubmit/onFile/fileName/note
     pair; this is the same behaviour as a real handler. The validation list,
     the message wording and the two note colours are the design's own.
     ⚠ Nothing here posts anywhere yet — the page collects and validates, and
     the send is wired up when the Shopify form app goes in. */
  function initForm() {
    var form = $('#asubForm');
    if (!form) return;
    var fileEl = $('#asubFile'), noteEl = $('#asubNote');
    var input = form.querySelector('input[type="file"]');
    var NONE = 'No file chosen yet';

    if (input) input.addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0];
      if (fileEl) fileEl.textContent = f ? f.name : NONE;
    });

    var note = function (ok, msg) {
      if (!noteEl) return;
      noteEl.textContent = msg;
      noteEl.style.color = ok === false ? '#7c3b34' : '#1a4e5f';
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; };
      var missing = [];
      if (!val('name')) missing.push('your name');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email'))) missing.push('a valid email address');
      if (!val('phone')) missing.push('a phone number');
      if (!val('project')) missing.push('an anthology project');
      if (!val('sampleText')) missing.push('your sample writing');

      if (missing.length) {
        note(false, 'Please add ' + missing.slice(0, 2).join(' and ') +
             (missing.length > 2 ? ', and the other required fields.' : '.'));
        var first = form.querySelector('[name="name"]');
        if (first && first.focus) first.focus({ preventScroll: true });
        return;
      }
      note(true, 'Thank you. Your sample is with our editors, and you will hear back by email.');
      form.reset();
      if (fileEl) fileEl.textContent = NONE;
    });
  }

  function init() { splitWords(); initReveal(); initScrollFX(); initFaq(); initThemes(); initForm(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
